import React from 'react';
import cx from 'classnames';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

export default function SequencingUndoButton({
  hideUndo,
  pointerTarget,
  undoEnabled,
  onUndo,
}) {
  return (
    <div className={cx('sequencing__undoBtn', { hidden: hideUndo })}>
      <AmiraIconButton
        type={ICON_BUTTON_TYPES.UNDO}
        oblong
        secondary
        onClick={() => undoEnabled && onUndo()}
        disabled={!undoEnabled}
        pointerPosition="left"
        showPointer={pointerTarget === 'undo'}
      />
    </div>
  );
}
